import * as V from "react";
import N from "react";
import { ReactDOM as b, PrimeReact as G, useUpdateEffect as q } from "./portal.esm.79076359.js";
import { jsx as P, ObjectUtils as X } from "./utils.esm.ea524c19.js";
import { propTypes as u } from "./index.dcccd5e7.js";
function D() {
  return D = Object.assign ? Object.assign.bind() : function(t) {
    for (var i = 1; i < arguments.length; i++) {
      var a = arguments[i];
      for (var e in a)
        Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
    }
    return t;
  }, D.apply(this, arguments);
}
function L(t, i) {
  if (t == null)
    return {};
  var a = {}, e = Object.keys(t), r, n;
  for (n = 0; n < e.length; n++)
    r = e[n], !(i.indexOf(r) >= 0) && (a[r] = t[r]);
  return a;
}
function R(t, i) {
  return R = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, r) {
    return e.__proto__ = r, e;
  }, R(t, i);
}
function A(t, i) {
  t.prototype = Object.create(i.prototype), t.prototype.constructor = t, R(t, i);
}
function W(t, i) {
  return t.classList ? !!i && t.classList.contains(i) : (" " + (t.className.baseVal || t.className) + " ").indexOf(" " + i + " ") !== -1;
}
function F(t, i) {
  t.classList ? t.classList.add(i) : W(t, i) || (typeof t.className == "string" ? t.className = t.className + " " + i : t.setAttribute("class", (t.className && t.className.baseVal || "") + " " + i));
}
function j(t, i) {
  return t.replace(new RegExp("(^|\\s)" + i + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function K(t, i) {
  t.classList ? t.classList.remove(i) : typeof t.className == "string" ? t.className = j(t.className, i) : t.setAttribute("class", j(t.className && t.className.baseVal || "", i));
}
const w = {
  disabled: !1
};
var H = process.env.NODE_ENV !== "production" ? u.exports.oneOfType([u.exports.number, u.exports.shape({
  enter: u.exports.number,
  exit: u.exports.number,
  appear: u.exports.number
}).isRequired]) : null, Y = process.env.NODE_ENV !== "production" ? u.exports.oneOfType([u.exports.string, u.exports.shape({
  enter: u.exports.string,
  exit: u.exports.string,
  active: u.exports.string
}), u.exports.shape({
  enter: u.exports.string,
  enterDone: u.exports.string,
  enterActive: u.exports.string,
  exit: u.exports.string,
  exitDone: u.exports.string,
  exitActive: u.exports.string
})]) : null;
const M = N.createContext(null);
var U = function(i) {
  return i.scrollTop;
}, O = "unmounted", h = "exited", m = "entering", C = "entered", y = "exiting", x = /* @__PURE__ */ function(t) {
  A(i, t);
  function i(e, r) {
    var n;
    n = t.call(this, e, r) || this;
    var o = r, s = o && !o.isMounting ? e.enter : e.appear, l;
    return n.appearStatus = null, e.in ? s ? (l = h, n.appearStatus = m) : l = C : e.unmountOnExit || e.mountOnEnter ? l = O : l = h, n.state = {
      status: l
    }, n.nextCallback = null, n;
  }
  i.getDerivedStateFromProps = function(r, n) {
    var o = r.in;
    return o && n.status === O ? {
      status: h
    } : null;
  };
  var a = i.prototype;
  return a.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, a.componentDidUpdate = function(r) {
    var n = null;
    if (r !== this.props) {
      var o = this.state.status;
      this.props.in ? o !== m && o !== C && (n = m) : (o === m || o === C) && (n = y);
    }
    this.updateStatus(!1, n);
  }, a.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, a.getTimeouts = function() {
    var r = this.props.timeout, n, o, s;
    return n = o = s = r, r != null && typeof r != "number" && (n = r.exit, o = r.enter, s = r.appear !== void 0 ? r.appear : o), {
      exit: n,
      enter: o,
      appear: s
    };
  }, a.updateStatus = function(r, n) {
    if (r === void 0 && (r = !1), n !== null)
      if (this.cancelNextCallback(), n === m) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var o = this.props.nodeRef ? this.props.nodeRef.current : b.findDOMNode(this);
          o && U(o);
        }
        this.performEnter(r);
      } else
        this.performExit();
    else
      this.props.unmountOnExit && this.state.status === h && this.setState({
        status: O
      });
  }, a.performEnter = function(r) {
    var n = this, o = this.props.enter, s = this.context ? this.context.isMounting : r, l = this.props.nodeRef ? [s] : [b.findDOMNode(this), s], f = l[0], d = l[1], E = this.getTimeouts(), c = s ? E.appear : E.enter;
    if (!r && !o || w.disabled) {
      this.safeSetState({
        status: C
      }, function() {
        n.props.onEntered(f);
      });
      return;
    }
    this.props.onEnter(f, d), this.safeSetState({
      status: m
    }, function() {
      n.props.onEntering(f, d), n.onTransitionEnd(c, function() {
        n.safeSetState({
          status: C
        }, function() {
          n.props.onEntered(f, d);
        });
      });
    });
  }, a.performExit = function() {
    var r = this, n = this.props.exit, o = this.getTimeouts(), s = this.props.nodeRef ? void 0 : b.findDOMNode(this);
    if (!n || w.disabled) {
      this.safeSetState({
        status: h
      }, function() {
        r.props.onExited(s);
      });
      return;
    }
    this.props.onExit(s), this.safeSetState({
      status: y
    }, function() {
      r.props.onExiting(s), r.onTransitionEnd(o.exit, function() {
        r.safeSetState({
          status: h
        }, function() {
          r.props.onExited(s);
        });
      });
    });
  }, a.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, a.safeSetState = function(r, n) {
    n = this.setNextCallback(n), this.setState(r, n);
  }, a.setNextCallback = function(r) {
    var n = this, o = !0;
    return this.nextCallback = function(s) {
      o && (o = !1, n.nextCallback = null, r(s));
    }, this.nextCallback.cancel = function() {
      o = !1;
    }, this.nextCallback;
  }, a.onTransitionEnd = function(r, n) {
    this.setNextCallback(n);
    var o = this.props.nodeRef ? this.props.nodeRef.current : b.findDOMNode(this), s = r == null && !this.props.addEndListener;
    if (!o || s) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var l = this.props.nodeRef ? [this.nextCallback] : [o, this.nextCallback], f = l[0], d = l[1];
      this.props.addEndListener(f, d);
    }
    r != null && setTimeout(this.nextCallback, r);
  }, a.render = function() {
    var r = this.state.status;
    if (r === O)
      return null;
    var n = this.props, o = n.children;
    n.in, n.mountOnEnter, n.unmountOnExit, n.appear, n.enter, n.exit, n.timeout, n.addEndListener, n.onEnter, n.onEntering, n.onEntered, n.onExit, n.onExiting, n.onExited, n.nodeRef;
    var s = L(n, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return /* @__PURE__ */ P(M.Provider, {
      value: null,
      children: typeof o == "function" ? o(r, s) : N.cloneElement(N.Children.only(o), s)
    });
  }, i;
}(N.Component);
x.contextType = M;
x.propTypes = process.env.NODE_ENV !== "production" ? {
  nodeRef: u.exports.shape({
    current: typeof Element > "u" ? u.exports.any : function(t, i, a, e, r, n) {
      var o = t[i];
      return u.exports.instanceOf(o && "ownerDocument" in o ? o.ownerDocument.defaultView.Element : Element)(t, i, a, e, r, n);
    }
  }),
  children: u.exports.oneOfType([u.exports.func.isRequired, u.exports.element.isRequired]).isRequired,
  in: u.exports.bool,
  mountOnEnter: u.exports.bool,
  unmountOnExit: u.exports.bool,
  appear: u.exports.bool,
  enter: u.exports.bool,
  exit: u.exports.bool,
  timeout: function(i) {
    var a = H;
    i.addEndListener || (a = a.isRequired);
    for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++)
      r[n - 1] = arguments[n];
    return a.apply(void 0, [i].concat(r));
  },
  addEndListener: u.exports.func,
  onEnter: u.exports.func,
  onEntering: u.exports.func,
  onEntered: u.exports.func,
  onExit: u.exports.func,
  onExiting: u.exports.func,
  onExited: u.exports.func
} : {};
function g() {
}
x.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: g,
  onEntering: g,
  onEntered: g,
  onExit: g,
  onExiting: g,
  onExited: g
};
x.UNMOUNTED = O;
x.EXITED = h;
x.ENTERING = m;
x.ENTERED = C;
x.EXITING = y;
const k = x;
var z = function(i, a) {
  return i && a && a.split(" ").forEach(function(e) {
    return F(i, e);
  });
}, S = function(i, a) {
  return i && a && a.split(" ").forEach(function(e) {
    return K(i, e);
  });
}, _ = /* @__PURE__ */ function(t) {
  A(i, t);
  function i() {
    for (var e, r = arguments.length, n = new Array(r), o = 0; o < r; o++)
      n[o] = arguments[o];
    return e = t.call.apply(t, [this].concat(n)) || this, e.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    }, e.onEnter = function(s, l) {
      var f = e.resolveArguments(s, l), d = f[0], E = f[1];
      e.removeClasses(d, "exit"), e.addClass(d, E ? "appear" : "enter", "base"), e.props.onEnter && e.props.onEnter(s, l);
    }, e.onEntering = function(s, l) {
      var f = e.resolveArguments(s, l), d = f[0], E = f[1], c = E ? "appear" : "enter";
      e.addClass(d, c, "active"), e.props.onEntering && e.props.onEntering(s, l);
    }, e.onEntered = function(s, l) {
      var f = e.resolveArguments(s, l), d = f[0], E = f[1], c = E ? "appear" : "enter";
      e.removeClasses(d, c), e.addClass(d, c, "done"), e.props.onEntered && e.props.onEntered(s, l);
    }, e.onExit = function(s) {
      var l = e.resolveArguments(s), f = l[0];
      e.removeClasses(f, "appear"), e.removeClasses(f, "enter"), e.addClass(f, "exit", "base"), e.props.onExit && e.props.onExit(s);
    }, e.onExiting = function(s) {
      var l = e.resolveArguments(s), f = l[0];
      e.addClass(f, "exit", "active"), e.props.onExiting && e.props.onExiting(s);
    }, e.onExited = function(s) {
      var l = e.resolveArguments(s), f = l[0];
      e.removeClasses(f, "exit"), e.addClass(f, "exit", "done"), e.props.onExited && e.props.onExited(s);
    }, e.resolveArguments = function(s, l) {
      return e.props.nodeRef ? [e.props.nodeRef.current, s] : [s, l];
    }, e.getClassNames = function(s) {
      var l = e.props.classNames, f = typeof l == "string", d = f && l ? l + "-" : "", E = f ? "" + d + s : l[s], c = f ? E + "-active" : l[s + "Active"], p = f ? E + "-done" : l[s + "Done"];
      return {
        baseClassName: E,
        activeClassName: c,
        doneClassName: p
      };
    }, e;
  }
  var a = i.prototype;
  return a.addClass = function(r, n, o) {
    var s = this.getClassNames(n)[o + "ClassName"], l = this.getClassNames("enter"), f = l.doneClassName;
    n === "appear" && o === "done" && f && (s += " " + f), o === "active" && r && U(r), s && (this.appliedClasses[n][o] = s, z(r, s));
  }, a.removeClasses = function(r, n) {
    var o = this.appliedClasses[n], s = o.base, l = o.active, f = o.done;
    this.appliedClasses[n] = {}, s && S(r, s), l && S(r, l), f && S(r, f);
  }, a.render = function() {
    var r = this.props;
    r.classNames;
    var n = L(r, ["classNames"]);
    return /* @__PURE__ */ P(k, {
      ...n,
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    });
  }, i;
}(N.Component);
_.defaultProps = {
  classNames: ""
};
_.propTypes = process.env.NODE_ENV !== "production" ? D({}, k.propTypes, {
  classNames: Y,
  onEnter: u.exports.func,
  onEntering: u.exports.func,
  onEntered: u.exports.func,
  onExit: u.exports.func,
  onExiting: u.exports.func,
  onExited: u.exports.func
}) : {};
const B = _;
function J(t, i, a) {
  return i in t ? Object.defineProperty(t, i, {
    value: a,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[i] = a, t;
}
function $(t, i) {
  var a = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var e = Object.getOwnPropertySymbols(t);
    i && (e = e.filter(function(r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), a.push.apply(a, e);
  }
  return a;
}
function T(t) {
  for (var i = 1; i < arguments.length; i++) {
    var a = arguments[i] != null ? arguments[i] : {};
    i % 2 ? $(Object(a), !0).forEach(function(e) {
      J(t, e, a[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(a)) : $(Object(a)).forEach(function(e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(a, e));
    });
  }
  return t;
}
var I = /* @__PURE__ */ V.forwardRef(function(t, i) {
  var a = t.disabled || t.options && t.options.disabled || !G.cssTransition, e = function(p, v) {
    t.onEnter && t.onEnter(p, v), t.options && t.options.onEnter && t.options.onEnter(p, v);
  }, r = function(p, v) {
    t.onEntering && t.onEntering(p, v), t.options && t.options.onEntering && t.options.onEntering(p, v);
  }, n = function(p, v) {
    t.onEntered && t.onEntered(p, v), t.options && t.options.onEntered && t.options.onEntered(p, v);
  }, o = function(p) {
    t.onExit && t.onExit(p), t.options && t.options.onExit && t.options.onExit(p);
  }, s = function(p) {
    t.onExiting && t.onExiting(p), t.options && t.options.onExiting && t.options.onExiting(p);
  }, l = function(p) {
    t.onExited && t.onExited(p), t.options && t.options.onExited && t.options.onExited(p);
  };
  if (q(function() {
    if (a) {
      var c = X.getRefElement(t.nodeRef);
      t.in ? (e(c, !0), r(c, !0), n(c, !0)) : (o(c), s(c), l(c));
    }
  }, [t.in]), a)
    return t.in ? t.children : null;
  var f = {
    nodeRef: t.nodeRef,
    in: t.in,
    onEnter: e,
    onEntering: r,
    onEntered: n,
    onExit: o,
    onExiting: s,
    onExited: l
  }, d = {
    classNames: t.classNames,
    timeout: t.timeout,
    unmountOnExit: t.unmountOnExit
  }, E = T(T(T({}, d), t.options || {}), f);
  return /* @__PURE__ */ P(B, {
    ...E,
    children: t.children
  });
});
I.displayName = "CSSTransition";
I.defaultProps = {
  __TYPE: "CSSTransition"
};
export {
  I as CSSTransition,
  M as TransitionGroupContext,
  D as _extends,
  A as _inheritsLoose,
  L as _objectWithoutPropertiesLoose
};
